var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-query-questions" },
    _vm._l(_vm.questions, function (item, index) {
      return _c("div", { key: item.id }, [
        _c("div", { staticClass: "row question-order" }, [
          _c("div", { staticClass: "small-11 medium-11 large-11 columns" }, [
            _c(
              "label",
              { class: { "required-flag": !(_vm.readonly || _vm.isBidder) } },
              [
                _vm._v(
                  _vm._s(_vm.$t("tender.query.question")) +
                    " " +
                    _vm._s(item.order)
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.allowDelete,
                  expression: "allowDelete",
                },
              ],
              staticClass: "columns delete-btn",
              on: {
                click: function ($event) {
                  return _vm.$emit("deleteQuestion", index)
                },
              },
            },
            [
              _c("i", {
                staticClass: "icon-delete",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        !(_vm.isBidder || _vm.readonly)
          ? _c(
              "div",
              { staticClass: "question-edit-mode" },
              [
                _c("TextField", {
                  staticClass: "question",
                  attrs: {
                    value: item.question,
                    placeholder: _vm.$t("tender.query.placeholder.question"),
                    parentNode: _vm.FORM_SRC_TENDER_QUERY,
                    required: "",
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.$emit("updateQuestion", index, "question", val)
                    },
                  },
                }),
              ],
              1
            )
          : _c("div", { staticClass: "question-view-mode" }, [
              _c(
                "div",
                { staticClass: "question" },
                [
                  _c("TextField", {
                    attrs: { readonly: true, value: item.question },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showAnswer
                ? _c(
                    "div",
                    { staticClass: "answer" },
                    [
                      _c("div", [
                        _c(
                          "label",
                          {
                            class: { "required-flag": _vm.contractorEditMode },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("tender.query.answer", [_vm.vendorName])
                              ) + ":"
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.readonly
                        ? _c(
                            "div",
                            { staticClass: "row readonly" },
                            [
                              _c("TextField", {
                                attrs: {
                                  readonly: true,
                                  value: _vm.getAnswer(item.answer),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.contractorEditMode
                        ? _c("TextField", {
                            attrs: {
                              value: item.answer,
                              placeholder: _vm.$t(
                                "tender.query.placeholder.answer"
                              ),
                              parentNode: _vm.FORM_SRC_TENDER_QUERY,
                              required: "",
                            },
                            on: {
                              updateValue: function (val) {
                                return _vm.$emit(
                                  "updateQuestion",
                                  index,
                                  "answer",
                                  val
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }